import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload';


import { ModalComponent } from './components/modal/modal.component';
import { EnumComponent } from './components/enum/enum.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { BreadCrumbsComponent } from './components/breadCrumbs/breadCrumbs.component';
import { PurchaseTypeComponent } from './components/purchaseType/purchaseType.component';
import { LoadingComponent } from './components/loading/loading.component';
import { UnitNoComponent } from './components/unit-no/unit-no.component';
import { TableConfigComponent } from './components/table-config/table-config.component';

import { PagePoolPipe } from './components/pagination/page-pool.pipe';
import { FormatPipe } from './pipes/format.pipe';
import { MomentPipe } from './pipes/moment.pipe';
import { SortByPipe } from './pipes/sortBy.pipe';
import { SafeUrlPipe } from './pipes/safeUrl.pipe';
import { ParsePipe } from './pipes/parse.pipe';
import { UrlDecodePipe } from './pipes/urlDecode.pipe';

import { FocusInput } from './directives/focusInput.directive';
import { DatePickerComponent } from './components/date-picker/date-picker.component';

const importModules = [
    CommonModule,
    FormsModule,
    RouterModule,
    NgZorroAntdModule,
    // FileUploadModule,
    TranslateModule.forChild()
];

const exportModules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    NgZorroAntdModule
];

const components = [
    ModalComponent,
    EnumComponent,
    PaginationComponent,
    BreadCrumbsComponent,
    PurchaseTypeComponent,
    DatePickerComponent,
    LoadingComponent,
    UnitNoComponent,
    TableConfigComponent
];

const directives = [
    FocusInput
];

const pipes = [
    FormatPipe,
    MomentPipe,
    SortByPipe,
    ParsePipe,
    PagePoolPipe,
    SafeUrlPipe,
    UrlDecodePipe
];

@NgModule({
    declarations: [
        ...components,
        ...directives,
        ...pipes
    ],
    imports: [
        ...importModules
    ],
    exports: [
        ...exportModules,
        ...components,
        ...directives,
        ...pipes
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/shared.module.ts